<div class="container mt-3">
  <div class="d-lg-flex justify-content-end">
    <div class="d-flex justify-content-end gap-3">
      <div class="form-floating" *ngIf="data">
        <p-dropdown class="py-2" id="data" [filter]="true" filterBy="name" styleClass="w-100" [optionLabel]="(lang.isAr | async) ? 'name' : 'nameEN'"
          optionValue="id" [options]="data" [placeholder]="'validation.select_client' | translate"
          (onChange)="display($event)"></p-dropdown>
      </div>
      <div class="form-floating" *ngIf="sites">
        <p-dropdown [filter]="true" filterBy="name" styleClass="w-100" [optionLabel]="(lang.isAr | async) ? 'name' : 'nameEN'" optionValue="id"
          [options]="sites" [placeholder]="'validation.select_site' | translate"
          (onChange)="display2($event)"></p-dropdown>
      </div>
      <div class="form-floating" *ngIf="branches">
        <p-dropdown class="py-2" id="branches" [filter]="true" filterBy="name" styleClass="w-100" [optionLabel]="(lang.isAr | async) ? 'name' : 'nameEN'"
          [options]="branches" [placeholder]="'validation.select_branch' | translate"
          (onChange)="getByBranchId($event)"></p-dropdown>
      </div>
      <div class="dropdown menue2">
        <button class="btn myPadding rounded-m rounded-8 btn-primary d-flex gap-2 align-items-center dropdown-toggle"
          type="button" id="dropdownMenuButton2" data-bs-toggle="dropdown" aria-expanded="false">
          <i class="fa-solid fa-sliders"></i>
          {{ "filtration" | translate }}
        </button>
        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
          <li class="dropdown-item cursor-pointer text-align-center" (click)="getDataFilter('client')">
            {{ "client" | translate }}
          </li>
          <li class="dropdown-item cursor-pointer text-align-center" (click)="getDataFilter('site')">
            {{ "site" | translate }}
          </li>
          <li *ngIf="isMainBranch" class="dropdown-item cursor-pointer text-align-center"
            (click)="getDataFilter('branch')">
            {{ "security_dashboard.dash.branches" | translate }}
          </li>
        </ul>
      </div>
      <div>
        <button (click)="deleteFilter()" class="btn myPadding rounded-m rounded-8 btn btn-secondary d-flex gap-2"
          type="button">
          {{ "filtrationDelete" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="container py-4">
  <!-- <div class="my-3">
    <div class="container card border-0 rounded-10">
      <div class="card-body">
        <div class="container d-flex justify-content-between">
          <h5 class="mt-3 mb-4">
            {{ "security_dashboard.dash.RecordedHour" | translate }}
          </h5>
          <div class="form-floating">
            <input type="email" class="form-control bg-info-o" id="input1" placeholder="date" bsDaterangepicker
              [maxDate]="maxDate" [formControl]="filterDate" [bsConfig]="{
                containerClass: 'theme-red',
                isAnimated: true,
                showWeekNumbers: false,
                adaptivePosition: true
              }" />
            <label for="input1" translate="date_range"></label>
          </div>
        </div>
        <app-my-chart></app-my-chart>
      </div>
    </div>
  </div> -->
  <!-- <div class="container">
    <div class="row">
      <div class="container-fluid  card border-0 rounded-10" *ngIf="statistic">
        <div class="card-body">
          <div class="row mt-3">
            <div class="col-lg col-md-6 my-1 pt-2 myboarder myboarder1">
              <h5 translate="security_dashboard.dash.totalHours"></h5>
              <p class>
                {{ totalHoure }}
              </p>
            </div>
            <div class="col-lg col-md-6 my-1 pt-2 myboarder myboarder2">
              <h5 translate="security_dashboard.dash.workHours"></h5>
              <p class>{{ totalWorkHoure }}</p>
            </div>
            <div class="col-lg col-md-6 my-1 pt-2 myboarder myboarder3">
              <h5 translate="security_dashboard.dash.breakHours"></h5>
              <p class>{{ totalBrackHoure }}</p>
            </div>
            <div class="col-lg col-md-6 my-1 pt-2 myboarder myboarder4">
              <h5 translate="security_dashboard.dash.overTimeHours"></h5>
              <p class>{{ totalExstraTime }}</p>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div> -->
</div>
<!----*ngIf="hide" depends on the package the user choose-->
<div class="container py-4">
  <div class="card h-100 border-0 rounded-10">
    <div class="card-body">
      <h5 class="fw-600 mt-2 mb-4" translate="reports.location_tracking"></h5>
      <!-- <div style="height: 450px" id="map"></div> -->
      <div style="height: 450px" class id="map">
        <!-- <google-map [options]="{ styles: style }" [center]="mainLocation" [zoom]="5">
          <map-marker-clusterer
            imagePath="https://raw.githubusercontent.com/googlearchive/js-marker-clusterer/gh-pages/images/m" [gridSize]="15" [maxZoom]="22">
            <map-marker *ngFor="let marker of markers" [position]="{ lat: +marker.lat, lng: +marker.lng }"
              #markerElem="mapMarker" [label]="{
                text: marker.name,
                className: 'marker'
              }" (mapClick)="
                openInfo(
                  markerElem,
                  marker.siteLocationName,
                  marker.guardCode,
                  marker.guardImage,
                  marker.name,
                  marker.birthDate,
                  marker.phoneNumber,
                  marker.age,
                  marker.nationalId,
                  marker.securityCompanyName,
                  marker.clientName,
                  marker.branchName,
                  marker.siteLocationName,
                  marker.supervisorName,
                  marker.siteNumber,
                  marker.shiftName,
                  marker.startTime
                )
              ">
            </map-marker>
            <map-info-window [innerHTML]="infoContent"></map-info-window>
          </map-marker-clusterer>
        </google-map>  -->
      </div>
    </div>
  </div>

  <div class="card mt-4 rounded-10 border-0">
    <div class="card-body">
      <!-- Nav tabs -->
      <div class="d-flex justify-content-between">
        <ul class="nav nav-tabs rounded-0 shadow-none" id="myTab" role="tablist">
          <li class="nav-item" role="presentation">
            <button class="nav-link active checkIn" id="checkIn-tab" data-bs-toggle="tab" data-bs-target="#checkIn"
              type="button" role="tab" aria-controls="checkIn" aria-selected="true">
              {{ "reports.checked_in" | translate }}
              <span class="badge bg-success">{{ checkedIn.length }}</span>
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link checkOut" id="checkout-tab" data-bs-toggle="tab" data-bs-target="#checkout"
              type="button" role="tab" aria-controls="checkout" aria-selected="false">
              {{ "reports.checked_out" | translate }}
              <span class="badge bg-success">{{ checkedOut.length }}</span>
            </button>
          </li>
          <li class="nav-item" role="presentation">
            <button class="nav-link break" id="break-tab" data-bs-toggle="tab" data-bs-target="#break" type="button"
              role="tab" aria-controls="break" aria-selected="false">
              {{ "reports.on_break" | translate }}
              <span class="badge bg-success">{{ break.length }}</span>
            </button>
          </li>
           <li class="nav-item" role="presentation">
            <button class="nav-link drawal" id="drawal-tab" data-bs-toggle="tab" data-bs-target="#drawal" type="button"
              role="tab" aria-controls="drawal" aria-selected="false">
              {{ "reports.drawal" | translate }}
              <span class="badge bg-success">{{ drawal.length }}</span>
            </button>
          </li>
        </ul>
      </div>
      <!-- Tab panes -->
      <div class="tab-content">
        <div class="tab-pane active" id="checkIn" role="tabpanel" aria-labelledby="checkIn-tab">
          <div class="py-3">
            <div class="">
              <div class="row my-3">
                <div class="col-md-6 col-12">
                  <div class="input-group p-0">
                    <span class="input-group-text border-0 bg-transparent" id="search">
                      <ion-icon name="search"></ion-icon>
                    </span>
                    <input type="text" class="form-control" [placeholder]="'search' | translate" aria-label="search"
                      aria-describedby="search" [(ngModel)]="searchKey" />
                    <button class="btn btn-success search text-white px-3 float-end" (click)="search('checkIn')"
                      translate="search">
                    </button>
                  </div>
                </div>
              </div>
              <div class="row row-cols-xl-3 row-cols-md-2 row-cols-1 g-4">
                <app-dash-guard-card *ngFor="let item of checkedIn" (click)="details(item)" class="cursor-pointer"
                  [data]="item" [totalWorkTime]="item.totalWorkTime" [startTime]="item.startTime"
                  [endTime]="item.leaveTime" [breakTime]="item.toTalBreakTime">
                </app-dash-guard-card>
              </div>
            </div>
            <div *ngIf="!checkedIn.length" class="mt-4 p-3 rounded-10 bg-info-o text-align-center fw-500"
              translate="no_data_to_show"></div>
          </div>
        </div>
        <div class="tab-pane" id="checkout" role="tabpanel" aria-labelledby="checkout-tab">
          <div class="py-3">
            <div class="">
              <div class="row my-3">
                <div class="col-md-6 col-12">
                  <div class="input-group p-0">
                    <span class="input-group-text border-0 bg-transparent" id="search">
                      <ion-icon name="search"></ion-icon>
                    </span>
                    <input type="text" class="form-control" [placeholder]="'search' | translate" aria-label="search"
                      aria-describedby="search" [(ngModel)]="searchKey" />
                    <button class="btn btn-success search text-white px-3 float-end" (click)="search('checkOut')"
                      translate="search">
                    </button>
                  </div>
                </div>
              </div>
              <div class="row row-cols-xl-3 row-cols-md-2 row-cols-1 g-4">
                <app-dash-guard-card *ngFor="let item of checkedOut" (click)="details(item)" class="cursor-pointer"
                  [data]="item" [totalWorkTime]="item.totalWorkTime" [startTime]="item.startTime"
                  [endTime]="item.leaveTime" [breakTime]="item.toTalBreakTime">
                </app-dash-guard-card>
              </div>
            </div>
            <div *ngIf="!checkedOut.length" class="mt-4 p-3 rounded-10 bg-info-o text-align-center fw-500"
              translate="no_data_to_show"></div>
          </div>
        </div>
        <div class="tab-pane" id="break" role="tabpanel" aria-labelledby="break-tab">
          <div class="py-3">
            <div class="">
              <div class="row my-3">
                <div class="col-md-6 col-12">
                  <div class="input-group p-0">
                    <span class="input-group-text border-0 bg-transparent" id="search">
                      <ion-icon name="search"></ion-icon>
                    </span>
                    <input type="text" class="form-control" [placeholder]="'search' | translate" aria-label="search"
                      aria-describedby="search" [(ngModel)]="searchKey" />
                    <button class="btn btn-success search text-white px-3 float-end" (click)="search('checkBreak')"
                      translate="search">
                    </button>
                  </div>
                </div>
              </div>
              <div class="row row-cols-xl-3 row-cols-md-2 row-cols-1 g-4">
                <app-dash-guard-card *ngFor="let item of break" (click)="details(item)" class="cursor-pointer"
                  [data]="item" [startTime]="item.startTime" [endTime]="item.leaveTime"
                  [breakTime]="item.toTalBreakTime">
                </app-dash-guard-card>
              </div>
            </div>
            <div *ngIf="!break.length" class="mt-4 p-3 rounded-10 bg-info-o text-align-center fw-500"
              translate="no_data_to_show"></div>
          </div>
        </div>
       <div class="tab-pane" id="drawal" role="tabpanel" aria-labelledby="break-tab">
          <div class="py-3">
            <div class="">
              <div class="row my-3">
                <div class="col-md-6 col-12">
                  <div class="input-group p-0">
                    <span class="input-group-text border-0 bg-transparent" id="search">
                      <ion-icon name="search"></ion-icon>
                    </span>
                    <input type="text" class="form-control" [placeholder]="'search' | translate" aria-label="search"
                      aria-describedby="search" [(ngModel)]="searchKey" />
                    <button class="btn btn-success search text-white px-3 float-end" (click)="search('checkDrawal')"
                      translate="search">
                    </button>
                  </div>
                </div>
              </div>
              <div class="row row-cols-xl-3 row-cols-md-2 row-cols-1 g-4">
                <app-dash-guard-card *ngFor="let item of drawal" (click)="withdrawndetails(item)" class="cursor-pointer"
                  [data]="item" [startTime]="item.startTime" [endTime]="item.leaveTime"
                  [breakTime]="item.toTalBreakTime">
                </app-dash-guard-card>
              </div>
            </div>
            <div *ngIf="!drawal.length" class="mt-4 p-3 rounded-10 bg-info-o text-align-center fw-500"
              translate="no_data_to_show"></div>
          </div>
        </div>  
      </div>
    </div>
  </div>
</div>

<public-api-modal [id]="guardDetailsId" classList="modal-dialog-centered">
  <div class="card border-0 mb-3">
    <div class="card-body">
      <div class="row">
        <div class="col-8">
          <div class="row">
            <div class="col-6">
              <h6 class="text-muted" translate="guard_name"></h6>
              <h6 class="">{{ guardDetails?.name }}</h6>
            </div>
            <div class="col-6">
              <h6 class="text-muted" translate="birth_date"></h6>
              <h6 class="">{{ guardDetails?.birthDate }}</h6>
            </div>
            <div class="col-6">
              <h6 class="text-muted" translate="contact_number"></h6>
              <h6 class="">{{ guardDetails?.phoneNumber }}</h6>
            </div>
            <div class="col-6">
              <h6 class="text-muted" translate="coveragesManagement.age"></h6>
              <h6 class="">{{ guardDetails?.age}}</h6>
            </div>
            <div class="col-6">
              <h6 class="text-muted" translate="national_id"></h6>
              <h6 class="">{{ guardDetails?.nationalId }}</h6>
            </div>
            <div class="col-6">
              <h6 class="text-muted" translate="ID"></h6>
              <h6 class="">{{ guardDetails?.guardCode }}</h6>
            </div>
          </div>
        </div>
        <div class="col-4">
          <img [src]="guardDetails?.guardImage" class="Imgfluid rounded CardImg" />
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-4">
          <h6 class="text-muted" translate="security_company"></h6>
          <h6 class="">{{ guardDetails?.securityCompanyName }}</h6>
        </div>
        <div class="col-4">
          <h6 class="text-muted" translate="clients.branch"></h6>
          <h6 class="">{{ guardDetails?.branchName }}</h6>
        </div>
        <div class="col-4">
          <h6 class="text-muted" translate="client"></h6>
          <h6 class="">{{ guardDetails?.clientName }}</h6>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-4">
          <h6 class="text-muted" translate="location"></h6>
          {{ guardDetails?.siteLocationName }}
        </div>
        <div class="col-4">
          <h6 class="text-muted" translate="clients.site_number"></h6>
          {{ guardDetails?.siteNumber ? guardDetails?.siteNumber : ('reports.no_data' | translate) }}
        </div>
        <div class="col-4">
          <h6 class="text-muted" translate="supervisor"></h6>
          <h6 class="">{{ guardDetails?.supervisorName }}</h6>
        </div>
        <div class="col-4">
          <h6 class="text-muted" translate="reports.shift"></h6>
          <h6 class="">{{ guardDetails?.shiftName }}</h6>
          <span class="px-1 mute">{{
            guardDetails?.mustStart?.split(" ")[1] | time
            }}</span>
          <span class="mx-1 px-1 mute">{{
            guardDetails?.mustEndIn?.split(" ")[1] | time
            }}</span>
        </div>
        <div class="col-4">
          <h6 class="text-muted" translate="clients.schedule"></h6>
          <h6 class="">{{ guardDetails?.scheduleName }}</h6>
        </div>
        <div class="col-4">
          <h6 class="text-muted" translate="reports.start_time"></h6>
          <h6 class="">{{ guardDetails?.startTime }}</h6>
        </div>
        <div *ngIf="guardDetails?.leaveTime" class="col-4">
          <h6 class="text-muted" translate="reports.end_time"></h6>
          <h6 class="">{{ guardDetails?.leaveTime }}</h6>
        </div>

        <div class="col-4">
          <h6 class="text-muted" translate="reports.break_time"></h6>
          <h6 class="">
            {{
            guardDetails?.totalBreakTime
            ? guardDetails?.totalBreakTime
            : ('reports.no_data' | translate)
            }}
          </h6>
        </div>
        <div *ngIf="guardDetails?.leaveTime" class="col-4">
          <h6 class="text-muted" translate="reports.logedOutBy"></h6>
          <h6 class="">{{guardDetails?.logedOutBy ? guardDetails?.logedOutBy : ("no-data" | translate)}}</h6>
        </div>
        <div class="col-6" *ngIf="guardDetails?.leaveTime == null">
          <h6 class="text-muted">{{'reports.work_hours_so_far' | translate}}</h6>
          <div class="row">
            <div class="col-6"><span>{{'reports.day_label' | translate}} : </span><span class="mute px-1">{{days}}</span></div>
            <div class="col-6"><span>{{'reports.hour_label' | translate}} : </span><span class="mute px-1">{{hours}}</span></div>
            <div class="col-6"><span>{{'reports.minute_label' | translate}} : </span><span class="mute px-1">{{minutes}}</span></div>
            <div class="col-6"><span>{{'reports.seconds_label' | translate}} : </span><span class="mute px-1">{{seconds}}</span></div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="d-flex justify-content-end gap-2 mt-3">
    <button translate="Voice Call" (click)="voiceCall(guardDetails)" data-bs-dismiss="modal" type="button"
    class="btn rounded-8 px-4 py-2 btn-primary text-white"></button>
    <button translate="Video Call" (click)="videoCall(guardDetails)" data-bs-dismiss="modal" type="button"
    class="btn rounded-8 px-4 py-2 btn-primary text-white"></button>
    <button translate="cancel" (click)="close(guardDetailsId)" data-bs-dismiss="modal" type="button"
      class="btn rounded-8 px-4 py-2 btn-primary text-white"></button>
  </div>
</public-api-modal>

<public-api-modal [id]="withdrawndetailsId" classList="modal-dialog-centered">
  <div class="card border-0 mb-3">
    <div class="card-body">
      <div class="row">
        <div class="col-8">
          <div class="row">
            <div class="col-6">
              <h6 class="text-muted" translate="guard_name"></h6>
              <h6 class="">{{ withdrawnGuardDetails?.name }}</h6>
            </div>
            <div class="col-6">
              <h6 class="text-muted" translate="birth_date"></h6>
              <h6 class="">{{ withdrawnGuardDetails?.birthDate }}</h6>
            </div>
            <div class="col-6">
              <h6 class="text-muted" translate="contact_number"></h6>
              <h6 class="">{{ withdrawnGuardDetails?.phoneNumber }}</h6>
            </div>
            <div class="col-6">
              <h6 class="text-muted" translate="coveragesManagement.age"></h6>
              <h6 class="">{{ withdrawnGuardDetails?.age}}</h6>
            </div>
            <div class="col-6">
              <h6 class="text-muted" translate="national_id"></h6>
              <h6 class="">{{ withdrawnGuardDetails?.nationalId }}</h6>
            </div>
            <div class="col-6">
              <h6 class="text-muted" translate="ID"></h6>
              <h6 class="">{{ withdrawnGuardDetails?.guardCode }}</h6>
            </div>
            <div class="col-6">
              <h6 class="text-muted" translate="totalHoure"></h6>
              <h6 class="">{{ withdrawnGuardDetails?.totalWorkTime ? withdrawnGuardDetails?.totalWorkTime.split('.')[0]
                : ('reports.no_data' | translate) }}</h6>
            </div>
          </div>
        </div>
        <div class="col-4">
          <img [src]="withdrawnGuardDetails?.guardImage" class="Imgfluid rounded CardImg" />
        </div>
      </div>
      <hr>
      <!-- <div *ngFor="let guardWithDrawn of guardWithDrawns" >
        <div class=" card-body"> -->
      <!-- <div class="my-2 cursor-pointer " [attr.data-bs-toggle]="'collapse'"
            [attr.data-bs-target]="'#' + safeCheckPointId(guardWithDrawn.id)" aria-expanded="false"> -->

      <!-- <div class="row mb-1 d-flex justify-content-center align-items-center">
        
              <div class="col-4 d-flex align-items-center justify-content-center">من</div>
              <div class="col-4 d-flex align-items-center justify-content-center">إلى</div>
              <div class="col-4 d-flex align-items-center justify-content-center">أجمالى مدة الأنسحاب</div>
            <div class="col-4 d-flex align-items-center justify-content-center">
              <span class="my-2">
                {{ guardWithDrawn.startTime }}
              </span>
            </div>
            <div class="col-4 d-flex align-items-center justify-content-center">
              <span class="my-2">
                {{ guardWithDrawn.endTime }}
              </span> -->
      <!-- <i class="fa-sharp fa-solid fa-caret-down mx-2"></i> -->
      <!-- </div>
            <div class="col-4 d-flex align-items-center justify-content-center">
              <span class="my-2">
                {{guardWithDrawn?.totalWithdrawalHours ?  guardWithDrawn?.totalWithdrawalHours.split('.')[0] : ' '}}
              </span> -->
      <!-- <i class="fa-sharp fa-solid fa-caret-down mx-2"></i> -->
      <!-- </div>
         
              <div  *ngIf="guardWithDrawn.withdrawalStatus == 0" class="col-6 d-flex align-items-center justify-content-center">
                <button translate="accept" (click)="accept(guardWithDrawn)"
                  class="btn rounded-8 px-4 py-2 btn-success text-white"></button>
              </div>
              <div  *ngIf="guardWithDrawn.withdrawalStatus == 0" class="col-6 d-flex align-items-center justify-content-center">
                <button translate="refuse" (click)="refuse(guardWithDrawn)"
                  class="btn rounded-8 px-4 py-2 btn-danger text-white"></button>
              </div>
          
         
              <div *ngIf="guardWithDrawn.withdrawalStatus == 1" class="dotApprove mx-2 ">لقد نم الموافقه على هذا الأنسحاب</div>
              <div *ngIf="guardWithDrawn.withdrawalStatus == 2" class="dotReject mx-2 ">لقد تم رفض هذا الأنسحاب</div>
          
          </div> -->
      <!-- </div> -->
       <div class="cardDrawn">
      <div class="flex-fill text-primary" *ngFor="
           let guardWithDrawn of guardWithDrawns">
        <table class="table table-striped table-bordered" id="excel-table">
          <thead>
            <tr>
              <th scope="col">{{'reports.from_label' | translate}}</th>
              <th scope="col">{{'reports.to_label' | translate}}</th>
              <th scope="col">{{'reports.total_withdrawal_duration' | translate}}</th>
            </tr>
          </thead>
          <tbody>
            <ng-container>
              <tr class="c-pointer">
                <td>{{ guardWithDrawn.startTime }}</td>
                <td>
                  {{ guardWithDrawn.endTime ? guardWithDrawn.endTime : ('reports.no_data' | translate) }}
                </td>
                <td>{{guardWithDrawn?.totalWithdrawalHours ?  guardWithDrawn?.totalWithdrawalHours.split('.')[0] : ('reports.no_data' | translate)}}</td>
              </tr>
            </ng-container>
          </tbody>
        </table>
        <div class="row">
          <div  *ngIf="guardWithDrawn.withdrawalStatus == 0" class="col-6 d-flex align-items-center justify-content-center">
            <button translate="accept" (click)="accept(guardWithDrawn)"
              class="btn rounded-8 px-4 py-2 btn-success text-white"></button>
          </div>
          <div  *ngIf="guardWithDrawn.withdrawalStatus == 0" class="col-6 d-flex align-items-center justify-content-center">
            <button translate="refuse" (click)="refuse(guardWithDrawn)"
              class="btn rounded-8 px-4 py-2 btn-danger text-white"></button>
          </div>
        </div>
        <div *ngIf="guardWithDrawn.withdrawalStatus == 1" class="dotApprove mx-2 ">{{'reports.withdrawal_approved' | translate}}</div>
        <div *ngIf="guardWithDrawn.withdrawalStatus == 2" class="dotReject mx-2 ">{{'reports.withdrawal_rejected' | translate}}</div>
        <hr>
      </div>
    
    <div *ngIf="!guardWithDrawns?.length">
      <div colspan="13">
        <h6 class="text-align-center fw-500 text-danger" translate="no_data_to_show"></h6>
      </div>
    </div>
    <!-- </div>
  </div> -->
</div>
    <div class="d-flex justify-content-end gap-2 mt-3">
      <button translate="cancel" (click)="close(withdrawndetailsId)" data-bs-dismiss="modal" type="button"
        class="btn rounded-8 px-4 py-2 btn-primary text-white"></button>
    </div>
    </div>
    </div>
</public-api-modal>


<public-api-modal [id]="withdrawnApprove" classList="modal-dialog-centered">
  <div class="card card-body my-2">

    <form [formGroup]="reasonForm" #form="ngForm" (ngSubmit)="onSubmit()">
      <div class="form-floating my-3">
        <textarea formControlName="Notes" class="form-control" placeholder="Enter details here" id="Notes"
          style="height: 100px" formControlName="Notes"></textarea>
        <label for="Notes" translate="invoices.refuse_reason"></label>
      </div>
      <div class="error-message" *ngIf="reasonForm.controls['Notes'].invalid && form.submitted">
        <i class="fa-sharp fa-solid fa-circle-exclamation"></i>
        {{ 'validation.field_required' | translate }}
      </div>
      <div class="d-flex justify-content-end gap-2 mt-3">
        <button translate="cancel" (click)="close(withdrawnApprove)" data-bs-dismiss="modal" type="button"
          class="btn rounded-8 px-4 py-2 btn-danger text-white"></button>
        <button translate="send" type="submit" class="btn rounded-8 px-4 py-2 btn-success text-white"></button>
      </div>
    </form>

  </div>
</public-api-modal>